import { queryOptions, useSuspenseQuery } from "@tanstack/react-query"

import { queryClient } from "../../app/components/providers/QueryProvider"
import { getDefaultLocales } from "../../app/services/locales"

export type UseDefaultLocalesResult = ReturnType<typeof useDefaultLocales>

export function useDefaultLocales() {
  const defaultLocalesQuery = useSuspenseQuery(defaultLocalesQueryOptions)

  return { defaultLocalesQuery }
}

const defaultLocalesQueryOptions = queryOptions({
  queryKey: ["defaultLocales"],
  queryFn: getDefaultLocales
})

export function prefetchDefaultLocalesQuery(): Promise<void> {
  return queryClient.prefetchQuery(defaultLocalesQueryOptions)
}
